<template>
  <navbar :show-navbar="showNavbar" :transparent="true" position="absolute">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{ toggled: $sidebar.showSidebar }">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
    </div>
    <button
      @click="toggleNavbar"
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navigation"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">
      <ul class="navbar-nav">
        <language-dropdown />
        <li>
          <button
            v-if="authorize"
            class="header__button btn btn-primary"
            @click="logout"
          >
            {{ $t("Log out") }}
          </button>
        </li>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { RouteBreadCrumb, Navbar, NavbarToggleButton } from './../ui'
import { CollapseTransition } from 'vue2-transitions'
import LanguageDropdown from './LanguageDropdown.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    RouteBreadCrumb,
    Navbar,
    NavbarToggleButton,
    CollapseTransition,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    'language-dropdown': LanguageDropdown
  },
  computed: {
    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    },
    authorize() {
      return localStorage.getItem('auth') !== 'false'
    },
    ...mapGetters({
      isMobile: 'menuIsMobile'
    }),
    ...mapState({
      header: state => state.config.data.header
    })
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    logout() {
      this.$store.dispatch('logout', false).then(() => this.$router.push('/'))
    },
    openMenu(e) {
      this.$store.dispatch('changeStateMenu', !this.$store.getters.menuIsOpen)
    },
    checkWidth() {
      if (window.innerWidth < 768) {
        this.$store.dispatch('changeStateMobile', true)
      } else {
        this.$store.dispatch('changeStateMobile', false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.flag-dropdown {
  display: flex;
  align-items: center;
  padding: 8px;
  & > img {
    margin-right: 4px;
    border: 1px solid white;
    border-radius: 50%;
  }
  &:hover {
    cursor: pointer;
    background-color: hsla(0,0%,100%,.2);
    border-radius: .1875rem;
  }
}
</style>>
